export default {
  customDetail: {
    commonCustomer: {
      uid: "",
      type: "2",
      categoryUid: "",
      categoryName: "",
      name: "",
      province: "",
      city: "",
      district: "",
    },
    hospital: "",
    department: "",
    doctorTitle: "",
    remark: "",
  },
  projectList: [],
  customList: {
    results: [],
  },
  medicalCustomList: {
    results: [],
  },
  customerApplyList: {},
  customContacts: {},
  customVisits: {},
  customBusi: {},
  customCompact: {},
  hospitalLevel: [],
  customerFollowUp: [],
  doctorList: {},
  operators: [],
  customArchiveData: {},
  doctorListData: {},
  customSalesman: {},
  finallyCustomData: {},
  refusedCustomData: {},
  governmentData: {},
  busiLine: {},
  investigationPerson: {},
  governmentDetail: {},
  projectData: [],
  proFollowData: {},
  teamList: [],
  projectDetailList: [],
  customerHoldBoolean: null,
  customType: [],
};
